import type { PromotionStatus } from "../api/promotionTypes";

const statusConfig: Record<PromotionStatus, { dot: string; text: string }> = {
  Active: { dot: "bg-green-500", text: "text-green-700" },
  Scheduled: { dot: "bg-blue-500", text: "text-blue-700" },
  Ended: { dot: "bg-gray-400", text: "text-gray-500" },
  "Sold out": { dot: "bg-amber-500", text: "text-amber-700" },
};

export function PromotionStatusBadge({ status }: { status: PromotionStatus }) {
  const config = statusConfig[status] || statusConfig.Ended;

  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <span className={`h-2 w-2 rounded-full ${config.dot}`} />
      <span className={config.text}>{status}</span>
    </span>
  );
}
